import { Icon } from 'antd-mobile';
import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './NumberOfStampsUsed.less';

export default class NumberOfStampsUsed extends OfficialPage {
  state = {
    verifyData: {
      success: false,
      qrcodeUrl: ''
    },
    useNumber: 1,
    couponDetail: {}
  }

  constructor(props) {
    super(props);
    document.title = '核销码';
  }

  componentDidMount() { }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let that = this
    let couponId = options.detail || '' // receive时为优惠券Id, use时为用户领取的优惠券Id
    let franchiseeId = options.franchisee || ''
    let useNumber = options.Number || 1
    app.sendRequest({
      url: '/index.php?r=AppShop/getUserListCouponInfo',
      data: {
        sub_app_id: franchiseeId,
        user_coupon_id: couponId
      },
      hideLoading: true,
      success: function (res) {
        that.setData({ couponDetail: res.data[0], useNumber: useNumber })
        that.getWriteOffCodeBox()
      }
    })
  }

  getWriteOffCodeBox = () => {
    var qrcodeUrl =
      `${app.globalData.siteBaseUrl}` +
      `/index.php?r=AppShop/couponQrcode&app_id=${
      this.data.franchiseeId ? this.data.franchiseeId : app.globalData.appId
      }` +
      `&user_coupon_id=${this.data.couponDetail.id}&consume_times=${this.data.useNumber}`
    this.setData({
      'verifyData.qrcodeUrl': qrcodeUrl
    })
    this.connectSocket()
  }
  hideCouponVerify = () => {
    let that = this
    clearInterval(this.timeInterval)
    this.socketOpen && app.closeSocket()
    app.turnBack()
  }
  timeInterval = ''
  socketOpen = false
  connectSocket = () => {
    var that = this
    app.connectSocket({
      url: 'wss://xcx.zhichiwangluo.com', //testonly
      header: {
        'content-type': 'application/json'
      },
      method: 'GET'
    })
    app.onSocketOpen(function (res) {
      that.socketOpen = true
      console.log('打开WebSocket')
      let data = {
        action: 'mark_client',
        user_token: app.globalData.userInfo.user_token,
        scenario_name: 'app_coupon_verify',
        session_key: app.globalData.sessionKey
      }
      app.sendSocketMessage({
        data: JSON.stringify(data)
      })
      that.timeInterval = setInterval(function () {
        console.log('打开轮询')
        let data = {
          action: 'heartbeat',
          user_token: app.globalData.userInfo.user_token,
          scenario_name: 'app_coupon_verify',
          session_key: app.globalData.sessionKey
        }
        app.sendSocketMessage({
          data: JSON.stringify(data)
        })
      }, 30000)
    })
    app.onSocketMessage(function (res) {
      let data = JSON.parse(res.data)
      if (data.action == 'push_to_client') {
        let msg = JSON.parse(data.msg)
        console.log(msg)
        if (msg.type == 'app_coupon_verify' && msg.status == 0) {
          that.setData({
            'verifyData.success': true
          })
          clearInterval(that.timeInterval)
          app.closeSocket()
        }
      }
    })
    app.onSocketClose(function (res) {
      that.socketOpen = false
      clearInterval(that.timeInterval)
      console.log('WebSocket 已关闭！')
    })
    app.onSocketError(function (res) {
      that.socketOpen = false
      console.log('WebSocket连接打开错误，请检查！')
    })
  }

  componentWillUnmount() {
    var that = this
    clearInterval(that.timeInterval)
    that.socketOpen && app.closeSocket()
  }

  render() {
    const { showGetUserInfo, verifyData, couponDetail } = this.state
    return (
      <React.Fragment>
        <div className="official-page number-of-stamps-used">
          <TopNav title="核销码"/>
          <div className="coupon-verify-wrap show">
            {/*  <view class="division-line">
                                                                                                                                                  <view class="left-circle" style={convertLineStyleData('background: {{ couponDetail.background }}')}></view>
                                                                                                                                                  <view class="right-circle" style={convertLineStyleData('background: {{ couponDetail.background }}')}></view>
                                                                                                                                                </view>  */}
            <div className="bottom-section">
              {!verifyData.success ? (
                <div className="verify-block">
                  <div className="qrcode">
                    <img src={verifyData.qrcodeUrl} />
                  </div>
                  <div className="code">
                    <div style={convertLineStyleData('color: #FF7100')}>核销码</div>
                    <div>{couponDetail.verify_code}</div>
                  </div>
                </div>
              ) : (
                  verifyData.success && (
                    <div className="success-block">
                      <div className="success-tip">
                        <Icon
                          className="success-tip-icon"
                          type="success"
                          size="xxs"
                        ></Icon>
                        <span className="success-tip-text">核销成功!</span>
                      </div>
                      <div className="back-tip" onClick={this.hideCouponVerify}>
                        >>>返回
                    </div>
                    </div>
                  )
                )}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/number-of-stamps-used/NumberOfStampsUsed.jsx